module.exports = __webpack_public_path__ + "static/img/kjdy12.054457e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newestqianniu/kjdy12.png
// module id = 327
// module chunks = 0